import styled from "styled-components"

const Nav = styled.nav`
  &,
  a,
  span,
  .active-link {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { Nav }
